/**************************************************
 * Nombre:       Tarjeta_Capacitaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, LinearProgress, Typography} from "@mui/material";
import {GRADIENTE} from "../../Constantes";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {Box} from "@mui/system";
import {useNavigate} from "react-router";
import {useContext, useEffect, useState} from "react";
import {obtenerPorcentajeCalificacion} from "../../CodigoNegocio/Capacitaciones/obtenerPorcentajeCalificacion";
import {PDFDownloadLink} from "@react-pdf/renderer";
import {usuarioContext} from "../../App";
import {ArrowForward} from "@mui/icons-material";
import Pdf_Certificado_Consultor from "../../CodigoNegocio/Pdfs/Pdf_Certificado_Consultor";
import {theme} from "../../Tema";


const Tarjeta_Capacitaciones = ({item, calificaciones, disponibles = true, escogida = ''}) => {
    const {sCell, masSM} = useResponsive()
    const cData = useContext(usuarioContext)
    const navigate = useNavigate()
    const [calificacion, setCalificacion] = useState({})


    useEffect(() => {

        let index = calificaciones.findIndex((e) => e.idCapacitacion === item.id)
        if (index > -1) {
            setCalificacion(calificaciones[index])
        }

    }, [calificaciones]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 6, sm: 6, md: 5}} sx={{
                justifyContent: 'flex-start',
                border: escogida === item.id ? 8 : 0,
                borderColor: theme.palette.primary.main,
                borderRadius: 4.5
            }}>
                <img src={item.img} width="100%" height={'auto'}
                     style={{
                         borderRadius: 10,
                         opacity: disponibles ? 1 : 0.5,
                     }}/>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 7}} sx={{justifyContent: 'flex-start', pl: 3}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{color: '#262626', fontSize: 18, fontWeight: 700, lineHeight: 1.1}}>
                            {item.nombre}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography sx={{
                            color: '#545454', fontSize: !masSM ? 14 : 14, fontWeight: 400, textOverflow: "ellipsis",
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: !masSM ? 5 : 6
                        }}>
                            {item.descripcion}
                        </Typography>
                    </Grid>

                    {calificacion.idCapacitacion &&

                        <>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: 1}}>
                                <Typography sx={{
                                    color: '#545454', fontSize: !masSM ? 14 : 14, fontWeight: 600,
                                }}>
                                    {`${obtenerPorcentajeCalificacion(calificacion)}% en test`}
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                <Box sx={{width: '100%'}}>
                                    <LinearProgress variant="determinate"
                                                    value={obtenerPorcentajeCalificacion(calificacion)}
                                                    sx={{height: 10}}/>
                                </Box>
                            </Grid>

                        </>
                    }

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}
                          spacing={sCell ? 0 : 2} alignItems={'center'}
                    >

                        {!masSM ?

                            <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                <IconButton
                                    disabled={!disponibles}
                                    onClick={() => navigate('/Caps/' + item.id)}
                                    sx={{background: GRADIENTE}}>
                                    <ArrowForward sx={{fill: "#fff"}}/>
                                </IconButton>
                            </Grid>


                            :

                            <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                <Button
                                    disabled={!disponibles}
                                    onClick={() => navigate('/Caps/' + item.id)}
                                    sx={{background: disponibles ? GRADIENTE : 'none', fontSize: 14}}
                                >Iniciar</Button>

                            </Grid>
                        }


                        {disponibles && calificacion.idCapacitacion && obtenerPorcentajeCalificacion(calificacion) >= 100 &&

                            <Grid container size={{xs: 8, sm: 8, md: 8}} sx={{justifyContent: 'flex-start'}}>
                                <PDFDownloadLink
                                    document={<Pdf_Certificado_Consultor usuario={cData.usuario} capacitacion={item}/>}
                                    fileName={"Certficado"}
                                    style={{textDecoration: "none"}}>
                                    <Button
                                        disabled={!disponibles}
                                        variant={'outlined'}
                                        sx={{fontSize: 14}}
                                    >Certificado</Button>
                                </PDFDownloadLink>
                            </Grid>


                        }
                    </Grid>

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Capacitaciones